import EventBus from '../../../../utils/event-bus'
import { get } from 'lodash'

/**
 * @description mezo ertek valtozasanak kiemelese
 * @param rowId
 * @param fieldName
 * @param fieldLabel
 * @param prop
 */
export function highlightChange(rowId = 0, fieldName, fieldLabel, prop) {
  const fields = document.querySelectorAll(`[name="${fieldName}"]`)
  const field = get(Array.from(fields), rowId)
  if (!field) return
  field.setAttribute('style', 'box-shadow: 0 0 10px green; transition: all 3s;')
  setTimeout(
    (field) => {
      field.setAttribute('style', 'box-shadow: none; transition: all 3s;')
    },
    2000,
    field,
  )
  EventBus.$emit('showExpNotification', {
    group: 'basic-notification',
    text: `${fieldName}_field_${prop}_changed`,
    properties: { fieldName: fieldLabel, prop: prop },
    title: 'calculation_changed',
    type: 'info',
  })
}
